"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appStoreReviews = exports.appStoreReviewsResultSchema = exports.appStoreReviewsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.appStoreReviewsArgsSchema = zod_1.z.object({
    trackId: zod_1.z
        .number()
        .describe('The trackId of the app to fetch reviews for (from appStoreMetadata)'),
    emitMode: common_1.emitModeSchema.default('single').describe('The mode to emit the results in.'),
    options: zod_1.z
        .object({
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if the search returns no results. Default to true.'),
    })
        .describe('Search options'),
});
// Result schema
exports.appStoreReviewsResultSchema = zod_1.z.array(zod_1.z.object({
    id: zod_1.z.string(),
    userName: zod_1.z.string(),
    title: zod_1.z.string(),
    content: zod_1.z.string(),
    rating: zod_1.z.number(),
    date: zod_1.z.string(),
    version: zod_1.z.string(),
}));
exports.appStoreReviews = (0, common_1.createEmitModeToolMetadata)({
    id: 'appStoreReviews',
    displayName: 'App Store Reviews',
    displayDescription: 'Fetch user reviews for an app from the Apple App Store by trackId.',
    category: 'search',
    color: common_1.BRAND_COLORS.WEB,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.WEB),
    icon: 'search',
    argsSchema: exports.appStoreReviewsArgsSchema,
}, {
    dependencies: ['options.failIfEmpty'],
    variants: [
        {
            when: { 'options.failIfEmpty': true },
            schema: exports.appStoreReviewsResultSchema,
        },
        {
            when: { 'options.failIfEmpty': false },
            schema: exports.appStoreReviewsResultSchema.nullable(),
        },
    ],
    defaultSchema: exports.appStoreReviewsResultSchema,
});
